<template>
	<div class="wrap-item">
		<div class="columns columns-custom">
				<div class="column">
					<p class="column-data">{{items.firstName}} {{ items.lastName }}</p>
				</div>
				<div class="column">
					<p class="column-data">{{items.email}}</p>
					
				</div>
				<div class="column">
					<p class="column-data">{{items.password}}</p>
					
				</div>
				<div class="column ">
					<template v-if="items.role=='app'">
					  <p class="column-data"><b>App</b></p>
          </template>
          <template v-else-if="items.role=='supervisor'">
            <p class="column-data"><b>Supervisor</b></p>
          </template>
          <template v-else-if="items.role=='master'">
            <p class="column-data"><b>Master</b></p>
          </template>
          <template v-else-if="items.role=='observer'">
            <p class="column-data"><b>Visor</b></p>
          </template>
				</div>
				<div class="column">
					<template v-if="items.status=='enabled'">
						<p class="label-state label-state--active-state column-data ">Activo</p>
					</template>
					<template v-else-if="items.status=='disabled'">
						<p class="label-state label-state--inactive-state column-data ">Inactivo</p>
					</template>
				</div> 
				<div class="column">
					<i class="item_icon material-icons btnEdit" @click="actionToLink(items.id)">edit</i>
				</div> 
    </div>
	</div>
</template>

<script>
export default {
  name: "itemTable",
  props: {
    items: {
      type: Object
    }
  },
  data() {
    return {
      // itemBase: [this.$props.items]
    };
  },
  methods: {
    actionToLink: function(id_user) {
      this.$router.push({name: "updateUser", params: {id: id_user}} );
    }
  }
};
</script>

<style lang="scss">
.column {
  position: relative;
  .column-data {
    position: relative;
    top: 50%;
    transform: translateY(-50%);

    overflow: hidden;
    max-width: 200px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .label-state {
    font-weight: bold;
    &--active-state {
      color: #00b34b;
    }
    &--inactive-state {
      // color: #de4356;
      color: #fa5a5f;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Componentes/itemTable.vue